import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
// import Navbar from "../components/Navbar";
import { clearEmployeeSession } from "../auth";
import EmployeeLayout from "../components/EmployeeLayout";


const ChangePassword = () => {
  const [form, setForm] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!form.current_password || !form.new_password || !form.confirm_password) {
      setError("All fields are required");
      return;
    }

    if (form.new_password !== form.confirm_password) {
      setError("New password and confirm password must match");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        current_password: form.current_password,
        new_password: form.new_password,
      };
      const res = await api.post("/employee/change-password", payload);
      setMessage(res.data?.message || "Password changed successfully");
      clearEmployeeSession();
      setTimeout(() => navigate("/login", { replace: true }), 800);
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        "Unable to change password. Please try again.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <EmployeeLayout>
    <div>
      {/* <Navbar onLogout={() => {
        clearEmployeeSession();
        navigate("/login", { replace: true });
      }} /> */}

      <div className="">
        <div className="">
          <div className="card-header">
            <h2>Change Password</h2>
            <p className="text-muted">
              Update your portal password. You will be logged out after a successful change.
            </p>
          </div>

          <form className="form-grid-1" onSubmit={handleSubmit}>
            <div className="field">
              <label className="field-label">Current Password</label>
              <input
                type="password"
                name="current_password"
                className="field-input"
                value={form.current_password}
                onChange={handleChange}
                autoComplete="current-password"
              />
            </div>
            <div className="field">
              <label className="field-label">New Password</label>
              <input
                type="password"
                name="new_password"
                className="field-input"
                value={form.new_password}
                onChange={handleChange}
                autoComplete="new-password"
              />
            </div>
            <div className="field">
              <label className="field-label">Confirm New Password</label>
              <input
                type="password"
                name="confirm_password"
                className="field-input"
                value={form.confirm_password}
                onChange={handleChange}
                autoComplete="new-password"
              />
            </div>

            {error && <div className="form-error">{error}</div>}
            {message && <div className="form-success">{message}</div>}

            <button className="btn-primary-large" type="submit" disabled={loading}>
              {loading ? "Saving..." : "Update Password"}
            </button>
          </form>
        </div>
      </div>
    </div>
    </EmployeeLayout>
  );
};

export default ChangePassword;
